import Routers from './routers';

function App() {
	return (
		<>
			<Routers />
		</>
	);
}

export default App;
